export default {
  zh: {
    thanksInfo: '感谢您申请加入我们成为Plex加速器联盟推广会员。',
    successNotice: '您的申请我们会尽快审核，请您耐心等待。我们会以邮件的方式联系您，如果您是手机注册用户，请您尽快绑定并激活邮箱。如有任何疑问请联系我们 ',
    sure: '确认'
  },
  en: {
    thanksInfo: 'Thanks for applying to join PlexVPN affiliate program.',
    successNotice: 'We’ll review your application as soon as possible, please be patient. We’ll contact you via email. If you signed up through phone number, please bind an email address and activate it. If you have any other questions or concerns, please contact us via ',
    sure: 'Sure'
  }
}



// WEBPACK FOOTER //
// ./src/components/becomeAffiliate/successModal/lang.js